<template>
  <div class="footer">
    <span class="text-black">
      {{ $t('tour_copyright_first') }} {{ $t('tour_copyright') }} / <a @click="openPolicy">クッキーポリシー</a> / <a @click="openTerms">規約</a>
    </span>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    openPolicy: function () {
      //クッキーポリシーを開く
      this.$router.push( {name: 'policy', params: { lang: this.lang } })
    },
    openTerms: function () {
      //規約を開く
      this.$router.push( {name: 'terms', params: { lang: this.lang } })
    },

  }
}
</script>
